import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute } from '@tanstack/react-router'
import { IndustrialConfiguratorPage } from '~/components/routes/industrial-configurator/industrial-configurator-page'
import { FeatureRouteGuard } from '~/components/route-guards'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/industrial-configurator')({
  staticData: {
    permission: ['read', 'previsions.industrial-configurator.kitchen'],
  },
  component: IndustrialConfiguratorRoute,
})

withRoutePermissions(Route)

function IndustrialConfiguratorRoute() {
  return (
    <FeatureRouteGuard flag={FLAGS.configurateurIndustriel}>
      <IndustrialConfiguratorPage />
    </FeatureRouteGuard>
  )
}
